module.exports = __webpack_public_path__ + "static/media/筹码洞察@2x.55a27022.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_172/images/筹码洞察@2x.png
// module id = 1573
// module chunks = 0